import { render, staticRenderFns } from "./product-action-list.vue?vue&type=template&id=585c5f1b&scoped=true"
import script from "./product-action-list.vue?vue&type=script&lang=ts"
export * from "./product-action-list.vue?vue&type=script&lang=ts"
import style0 from "./product-action-list.vue?vue&type=style&index=0&id=585c5f1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585c5f1b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
